import * as React from "react";
import {RouterView, LoadingViewState} from "../../RouterView";
import {kernel} from "../../../../ioc/IOCHelper";
import {Symbols} from "../../../../ioc/Symbols";
import {HistoricTournament, TournamentEvent, Account} from "../../../../../generated/protocol";
import {TournamentHistoryService} from "../../../../service/poker/history/TournamentHistoryService";
import {HistoricTournamentComponent} from "../../../poker/history/HistoricTournamentComponent";
import {WALLET_SERVICE_NAME, WalletService} from "../../../../service/admin/WalletService";
import {AppCtx} from "../../../../ioc/ApplicationContext";


interface State extends LoadingViewState {
    tournament?: HistoricTournament;
    linkedTournaments?: HistoricTournament[];
    showAllEvents?: boolean;
    showAllPositions?: boolean;
    showAllRegistered?: boolean;
    playerOutMap?: Map<number, TournamentEvent>;
}

interface Props {
    params: { id: string }
}

export class HistoricTournamentView extends RouterView<Props, State> {

    service: TournamentHistoryService;
    walletService: WalletService;

    constructor(props: Props) {
        super(props);
        this.service = kernel.get<TournamentHistoryService>(Symbols.TournamentHistoryService);
        this.walletService = AppCtx.resolve<WalletService>(WALLET_SERVICE_NAME);
    }

    loadContent(): Promise<any> | void {
        let that = this;
        return this.service.getEntity(this.props.params.id).then((tournament: HistoricTournament) => {
            that.state.playerOutMap = that.createPlayerOutMap(tournament.events);

            let linkedTournamentsHistoricIds = [];
            if (tournament.positions.length > 0) {
                let winnerPosition = tournament.positions[tournament.positions.length - 1];
                if (winnerPosition.ticketNameId) {
                    let winner = winnerPosition.playerId;
                    let satelliteTargetHistoricId = that.state.playerOutMap.get(winner).historicTournamentId;
                    linkedTournamentsHistoricIds.push(satelliteTargetHistoricId);
                }
            }

            tournament.events.forEach((e: TournamentEvent) => {
                if (
                    (e.eventType == "PLAYER_REGISTERED" || e.event.indexOf("registered") > 0)
                    && e.historicTournamentId
                    && linkedTournamentsHistoricIds.indexOf(e.historicTournamentId) < 0
                ) {
                    linkedTournamentsHistoricIds.push(e.historicTournamentId);
                }
            });

            if (linkedTournamentsHistoricIds.length > 0) {
                that.service.getEntities(linkedTournamentsHistoricIds).then((linkedTournaments: HistoricTournament[]) => {
                    that.setState({linkedTournaments: linkedTournaments})
                });
            }

            this.setState({
                tournament: tournament,
                linkedTournaments: null,
                showAllEvents: false,
                showAllPositions: false,
                showAllRegistered: false
            });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.id != this.props.params.id) {
            this.refreshContent();
        } else {
            super.componentDidUpdate(prevProps, prevState);
        }
    }

    isShowContentWhenOnRefresh(): boolean {
        return true;
    }

    togglePositions() {
        this.setState({showAllPositions: !this.state.showAllPositions});
    }

    toggleEvents() {
        this.setState({showAllEvents: !this.state.showAllEvents});
    }

    toggleRegistered() {
        this.setState({showAllRegistered: !this.state.showAllRegistered});
    }

    createPlayerOutMap(events: TournamentEvent[]): Map<number, TournamentEvent> {
        let playerOutMap = new Map<number, TournamentEvent>();
        events.forEach((e) => {
            if (e.eventType == "PLAYER_OUT" || e.event.indexOf("out") > 0) {
                playerOutMap.set(e.playerId, e);
            }
        });
        return playerOutMap;
    }

    navigateTo(historicTournamentId: string) {
        this.navigate("/historic-tournament/" + historicTournamentId);
    }

    renderContent(): JSX.Element {

        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Tournament : {this.state.tournament.tournamentName}</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated" style={{opacity: this.state.loading ? 0.5 : 1}}>
                    <HistoricTournamentComponent
                        tournament={this.state.tournament}
                        linkedTournaments={this.state.linkedTournaments}
                        showAllRegistered={this.state.showAllRegistered}
                        toggleRegistered={this.toggleRegistered.bind(this)}
                        togglePositions={this.togglePositions.bind(this)}
                        toggleEvents={this.toggleEvents.bind(this)}
                        showAllEvents={this.state.showAllEvents}
                        showAllPositions={this.state.showAllPositions}
                        playerOutMap={this.state.playerOutMap}
                    />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/view/poker/history/HistoricTournamentView.tsx